import {postCall} from "./http.service";
import {SEARCH_PROJECTS_ACTION} from "../config/endpoints/location";


async function allProjects(params,page) {
    let url = SEARCH_PROJECTS_ACTION + '?page=' + page;
    return await postCall(url, params);
}

export { allProjects };
